// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"transform-component_wrapper__1b9-X","content":"transform-component_content__2Dugt"};